import AppHeader from '../../../components/AppHeader';
import Loader from '../../../components/Loader';
import NoData from '../../../components/NoData';
import OpacityAnimation from '../../../components/OpacityAnimation';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import WorkplacesRadioButtons from '../../../components/WorkplacesRadioButtons';
import { useAppContext } from '../../../contexts/auth';
import Filters from './components/Filters';
import InactivateModal from './components/InactivateModal';
import InfoModal from './components/InfoModal';
import List from './components/List';
import ListHeader from './components/ListHeader';
import PassengerRoutingModal from './components/PassengerRoutingModal';
import ReactivateModal from './components/ReactivateModal';
import usePassengers from './usePassengers';

export default function Passengers() {
  const {
    isLoading,
    handleChangeSearchCpfTerm,
    searchCpfTerm,
    workplaces,
    filteredPassengers,
    doesWorkplacesListExists,
    doesPassengersListExists,
    apiWorkplaceFetched,
    apiPassengersFetched,
    selectedWorkplace,
    searchNameTerm,
    searchConsultTerm,
    selectedGoingLine,
    selectedBackLine,
    selectedStatus,
    passengerBeingReactivated,
    pasengerBeingInactivated,
    passengerRoutingBeingShow,
    reactivateModalShow,
    inactivateModalShow,
    passengerRoutingModalShow,
    handleOpenReactivateModal,
    handleOpenInactivateModal,
    handleOpenPassengerRoutingModal,
    handleWorkplaceChange,
    handleChangeSearchNameTerm,
    handleChangeSearchConsultTerm,
    handleChangeSelectedGoingLine,
    handleChangeSelectedBackLine,
    handleChangeSelectedStatus,
    handleTryGetWorkplacesAgain,
    handleTryGetpassengersAgain,
    isInactivating,
    handleInactivatePassenger,
    isReactivateDateSet,
    reactivateDate,
    setReactivateDate,
    handleReactivateDateChange,
    isReactivating,
    handleActivatePassenger,
    setIsReactivateDateSet,
    passengerInfoBeingShow,
    infoModalShow,
    handleOpenPassengerInfoModal,
    goingLineOptions,
    backLineOptions,
    statusOptions,
    setInactivateModalShow,
    setReactivateModalShow,
    setInfoModalShow,
    setPassengerRoutingModalShow,
  } = usePassengers();

  const { selectedCompany } = useAppContext();
  // const { userProfile } = userData;
  const isCompanySelected = !!selectedCompany.value;
  const companyHasWorkplace = doesWorkplacesListExists && apiWorkplaceFetched;
  const passengersApiHasError = !!selectedWorkplace.value && !apiPassengersFetched && !isLoading;
  const workplaceHasAnyPassengers = !!selectedWorkplace.value && apiPassengersFetched && !doesPassengersListExists && !isLoading;
  const hasPassengers = selectedWorkplace.value && apiPassengersFetched && doesPassengersListExists && !isLoading;
  const isFilteredListEmpty = filteredPassengers?.length === 0;
  const workplacesApiHasError = !apiWorkplaceFetched && !isLoading;

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Passengers" />
      <Transitions>
        <Loader isLoading={isLoading || isInactivating || isReactivating} />

        {isCompanySelected && (
          <>
            {companyHasWorkplace && (
              <OpacityAnimation delay={0.1}>
                <WorkplacesRadioButtons
                  apiWorkplaceFetched={apiWorkplaceFetched}
                  doesWorkplacesListExists={doesWorkplacesListExists}
                  handleWorkplaceChange={handleWorkplaceChange}
                  handleTryGetWorkplacesAgain={handleTryGetWorkplacesAgain}
                  isLoading={isLoading}
                  workplaces={workplaces}
                  selectedWorkplace={selectedWorkplace}
                  showAllButton={false}
                />
                {!selectedWorkplace.value && (
                  <NoData icon="passenger" label={<>Selecione um local de trabalho acima para exibir a lista de passageiros do sistema de fretamento do mesmo</>} />
                )}

                {passengersApiHasError && (
                  <NoData
                    icon="sad"
                    label={(
                      <>
                    Ocorreu um erro ao carregar os passageiros.
                        <button type="button" onClick={() => handleTryGetpassengersAgain(selectedWorkplace.value)}>Tentar Novamente</button>
                      </>
                    )}
                  />
                )}

                {workplaceHasAnyPassengers && (
                  <NoData
                    icon="emptyBox"
                    label={(
                      <>
                      Este local de trabalho não tem nenhum passageiro,
                      tente selecionar outro local de trabalho acima!
                      </>
                    )}
                  />
                )}

                {hasPassengers && (
                  <>
                    <Filters
                      searchNameTerm={searchNameTerm}
                      handleChangeSearchNameTerm={handleChangeSearchNameTerm}
                      searchCpfTerm={searchCpfTerm}
                      handleChangeSearchCpfTerm={handleChangeSearchCpfTerm}
                      searchConsultTerm={searchConsultTerm}
                      handleChangeSearchConsultTerm={handleChangeSearchConsultTerm}
                      selectedGoingLine={selectedGoingLine}
                      handleChangeSelectedGoingLine={handleChangeSelectedGoingLine}
                      selectedBackLine={selectedBackLine}
                      handleChangeSelectedBackLine={handleChangeSelectedBackLine}
                      selectedStatus={selectedStatus}
                      handleChangeSelectedStatus={handleChangeSelectedStatus}
                      goingLineOptions={goingLineOptions}
                      backLineOptions={backLineOptions}
                      statusOptions={statusOptions}
                    />

                    <ListHeader
                      apiFetched={apiPassengersFetched}
                      doesListExists={doesPassengersListExists}
                      filteredEntity={filteredPassengers}
                      entityString={{ singular: 'passageiro', plural: 'passageiros' }}
                    />

                    {!isFilteredListEmpty && (
                      <>
                        <List
                          filteredPassengers={filteredPassengers}
                          handleOpenPassengerRoutingModal={handleOpenPassengerRoutingModal}
                          handleOpenInactivateModal={handleOpenInactivateModal}
                          handleOpenReactivateModal={handleOpenReactivateModal}
                          handleOpenPassengerInfoModal={handleOpenPassengerInfoModal}
                        />

                        <InactivateModal
                          passengerName={pasengerBeingInactivated}
                          isReactivateDateSet={isReactivateDateSet}
                          setIsReactivateDateSet={setIsReactivateDateSet}
                          inactivateModalShow={inactivateModalShow}
                          setInactivateModalShow={setInactivateModalShow}
                          reactivateDate={reactivateDate}
                          handleReactivateDateChange={handleReactivateDateChange}
                          setRehabilitateDate={setReactivateDate}
                          handleInactivatePassenger={() => handleInactivatePassenger()}
                        />

                        <ReactivateModal
                          passengerName={passengerBeingReactivated}
                          isReactivateDateSet={isReactivateDateSet}
                          setIsReactivateDateSet={setIsReactivateDateSet}
                          reactivateModalShow={reactivateModalShow}
                          setReactivateModalShow={setReactivateModalShow}
                          reactivateDate={reactivateDate}
                          handleReactivateDateChange={handleReactivateDateChange}
                          setRehabilitateDate={setReactivateDate}
                          handleActivatePassenger={handleActivatePassenger}
                        />

                        <InfoModal
                          passengerInfo={passengerInfoBeingShow}
                          infoModalShow={infoModalShow}
                          setInfoModalShow={setInfoModalShow}
                        />

                        <PassengerRoutingModal
                          passengerInfo={passengerRoutingBeingShow}
                          routingModalShow={passengerRoutingModalShow}
                          setRoutingModalShow={setPassengerRoutingModalShow}
                        />
                      </>
                    )}

                    {isFilteredListEmpty && (
                      <NoData
                        icon="searchNotFound"
                        label={(
                          <>
                      Nenhum passageiro foi encontrado conforme campos de filtros preenchidos.
                          </>
                        )}
                      />
                    )}

                  </>
                )}
              </OpacityAnimation>
            )}

            {!companyHasWorkplace && (
              <NoData icon="emptyBox" label={<>Esta empresa não possui locais de trabalho cadastrados. Para visualizar os passageiros do sistema de fretamento, a empresa precisa ter pelo menos um local de trabalho cadastrado. </>} />
            )}

            {workplacesApiHasError && (
              <NoData
                icon="sad"
                label={(
                  <>
                  Ocorreu um erro ao obter os locais de trabalho para exibir os passageiros.
                    <button type="button" onClick={handleTryGetWorkplacesAgain}>Tentar Novamente</button>
                  </>
                )}
              />
            )}
          </>
        )}

        {!selectedCompany.value && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
                Selecione uma empresa para visualizar os passageiros.
              </>
            )}
          />
        )}

      </Transitions>
    </>
  );
}
